import type { FC } from "react";

import { cn } from "@/utils/common/styleHelper/utils";

interface Props {
  className?: string;
}

const Skeleton: FC<Props> = ({ className = "" }) => {
  return (
    <div
      className={cn(
        "animate-pulse group relative overflow-hidden pointer-events-none before:opacity-100 before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:border-t before:border-content4/30 before:bg-gradient-to-r before:from-transparent before:via-content4 dark:before:via-default-700/10 before:to-transparent after:opacity-100 after:absolute after:inset-0 after:-z-10 flex items-center transition-background duration-300 ease-[ease] rounded-lg bg-skeleton w-fit",
        className,
      )}
    />
  );
};

export default Skeleton;
